export function isTestItem(...names: (string | undefined)[]): boolean {
  return names.some((name) => /\btest\b/i.test(name ?? ""));
}
